import {
  GET_CANDIDATE_ASSESSMENT_STATUS,
  GET_CANDIDATE_ASSESSMENT_STATUS_SUCCESS,
  GET_CANDIDATE_ASSESSMENT_STATUS_ERROR,
  GET_CANDIDATE_ASSESSMENT_OVERRIDE,
  GET_CANDIDATE_ASSESSMENT_OVERRIDE_SUCCESS,
  GET_CANDIDATE_ASSESSMENT_OVERRIDE_ERROR,
} from "./actionTypes";

const initialState = {
  assessmentLoading: false,
  assessmentStatus: null,
  assessmentError: null,
  overRideStatus: null,
  overRideError: null,
};

const ProcessAssessmentDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CANDIDATE_ASSESSMENT_STATUS:
      state = {
        ...state,
        assessmentLoading: true,
        assessmentStatus: null,
        assessmentError:null
      };
      break;
    case GET_CANDIDATE_ASSESSMENT_STATUS_SUCCESS:
      state = {
        ...state,
        assessmentLoading: false,
        assessmentStatus: action.payload,
        assessmentError:null
      };
      break;
    case GET_CANDIDATE_ASSESSMENT_STATUS_ERROR:
      state = {
        ...state,
        assessmentLoading: false,
        assessmentStatus: null,
        assessmentError: action.payload,
      };
      break;
      case GET_CANDIDATE_ASSESSMENT_OVERRIDE:
      state = {
        ...state,
        assessmentLoading: true,
        overRideStatus:null,
        overRideError:null
      };
      break;
    case GET_CANDIDATE_ASSESSMENT_OVERRIDE_SUCCESS:
      state = {
        ...state,
        assessmentLoading: false,
        overRideStatus:action.payload,
        overRideError:null
      };
      break;
    case GET_CANDIDATE_ASSESSMENT_OVERRIDE_ERROR:
      state = {
        ...state,
        assessmentLoading: false,
        overRideStatus:null,
        overRideError:action.payload
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ProcessAssessmentDetailsReducer;
